import { BaseCategorizer } from './BaseCategorizer';
import type { Transaction, CategorizationResult, CategorizationContext } from '../types';

/**
 * User Categorizer
 * Handles manual categorization overrides
 * This has the highest priority - if user manually categorized, always respect it
 */
export class UserCategorizer extends BaseCategorizer {
  constructor() {
    super('UserCategorizer', 1); // Highest priority
  }

  canCategorize(transaction: Transaction, context: CategorizationContext = {}): boolean {
    // Only applies to transactions that have been manually categorized
    return transaction.categorySource === 'user';
  }

  async categorize(
    transaction: Transaction,
    context: CategorizationContext = {}
  ): Promise<CategorizationResult> {
    // If user manually categorized, return with 100% confidence
    if (transaction.categorySource === 'user') {
      return {
        category: transaction.category || 'Uncategorized',
        confidence: 1.0,
        method: 'user'
      };
    }

    // Should never reach here due to canCategorize check
    return {
      category: transaction.category || 'Uncategorized',
      confidence: 0.0,
      method: 'none'
    };
  }

  getInfo() {
    return {
      ...super.getInfo(),
      type: 'user-override',
      description: 'Preserves manual user categorization with highest priority'
    };
  }
}
